import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgBuilding2 = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M4 22V3a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v19" />
      <path
        d="M14.5 1.5a1.5 1.5 0 0 1 1.493 1.356L16 3v19a1 1 0 0 1-1.993.117L14 22V3.5H5V22a1 1 0 0 1-.883.993L4 23a1 1 0 0 1-.993-.883L3 22V3a1.5 1.5 0 0 1 1.356-1.493L4.5 1.5h10Z"
        fill="currentColor"
        fillRule="nonzero"
      />
      <path
        d="M14.142 6.986a1 1 0 0 1 1.269-.398l.103.054 5 3a1 1 0 0 1 .477.727l.009.13V22a1 1 0 0 1-1.993.117L19 22V11.066l-4.514-2.708a1 1 0 0 1-.398-1.269l.054-.103Z"
        fill="currentColor"
        fillRule="nonzero"
      />
      <path
        d="M22 21a1 1 0 0 1 .117 1.993L22 23H2a1 1 0 0 1-.117-1.993L2 21h20Z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgBuilding2)
const Memo = memo(ForwardRef)
export default Memo
